import AttachmentsCollection from "../../attachment/attachments"
import Document from "../document"

// @ts-ignore
import AttachmentsManager from "../../../../core/gd-components/files/attachments-manager/attachments-manager"

export default class DocumentPage {

    public document               : Document

    public id                     : ID

    public title                  : string
    public content                : string
    public contentRTF             : any
    public attachments            : any[]

    public hasChanged             : boolean

    public attachmentsCollection  : AttachmentsCollection    // used on a client only

    constructor(data: any, document: Document) {
        this.document               = document // root document model link

        this.id                     = _.get(data, 'id', gd.utils.guid())

        this.title                  = _.get(data, 'title', 'New Page')
        this.content                = _.get(data, 'content', '')
        this.contentRTF             = _.get(data, 'contentRTF', null)
        this.attachments            = _.get(data, 'attachments', [])

        this.hasChanged             = false // will indicate that wee need to save (!)

        this.attachmentsCollection  = new AttachmentsCollection(this.attachments)
    }

    prepareAttachments = (attachmentManager: AttachmentsManager, canEdit: boolean) => {
        // remove from content
        if (this.contentRTF) {
            this.attachmentsCollection.applyMessageRTF(this.contentRTF)
        }

        // hitrii hack chto bi po drugomu render inside editora
        if (canEdit) {
            _.map(this.attachmentsCollection._models, attachment=>{
                attachment.renderMode = 'notes-edit'
                attachment.refAttachmentManager = attachmentManager
            })
        }
    }

    update = (data: any) => {
        if (!_.isNil(data.title))       this.title = data.title
        if (!_.isNil(data.content))     this.content = data.content
        if (!_.isNil(data.contentRTF))  this.contentRTF = data.contentRTF

        // it can be nil easily.... :)
        this.attachments = data.attachments
    }

    toJSON() {
        return {
            id:             this.id,
            title:          this.title,
            content:        this.content,
            contentRTF:     this.contentRTF,
            attachments:    this.attachmentsCollection.toJSON()
        }
    }
}